import * as React from 'react';
import { IMostViewedSolutionsResponse, AppConsumer } from 'src/contexts/Context';
import { WideContainer } from 'src/components/Container/Container';
import { Loader } from 'src/components/Loader/Loader';
import { ViewTable } from 'src/components/ViewsTable/ViewTable';
import { Flex, FlexDirection } from 'src/components/Flex/Flex';
import { FlexContent } from 'src/components/FlexContent/FlexContent';
import { ResponsiveSize, FlexPosition, REPORT_ROW_COUNT } from 'src/components/Globals/Globals';
import { H2, H1 } from 'src/components/Elements/Elements';
import { Link } from 'react-router-dom';
import { BackButton } from 'src/components/Button/Button';

interface IReportProps {
  getViewCounts(count: number): Promise<IMostViewedSolutionsResponse>;
  waitForSolutionsLoaded(): Promise<{}>;
}

interface IReportState {
  viewCounts?: IMostViewedSolutionsResponse;
  loading: boolean;
}

// Report page shows a report of most viewed and popular solutions and materials.
export class Report extends React.Component<IReportProps, IReportState> {
  constructor(props: IReportProps) {
    super(props);

    this.state = {
      viewCounts: undefined,
      loading: true
    };

    this.init = this.init.bind(this);
  }

  public componentDidMount() {
    this.init();
  }

  public async init() {
    await this.props.waitForSolutionsLoaded();
    this.setState({ viewCounts: await this.props.getViewCounts(REPORT_ROW_COUNT) });
  }

  public render() {
    return (
      <AppConsumer>
        {({ apiActions }) => (
          <WideContainer style={{ paddingTop: '20px' }}>
            <Flex
              alignHorizontal={FlexPosition.center}
              style={{ marginTop: '1em', marginBottom: '1em' }}
            >
              <Link to="/">
                <BackButton>&laquo; Return to front page</BackButton>
              </Link>
            </Flex>
            {!this.state.viewCounts ? (
              <Loader />
            ) : (
              <Flex tileAfter={ResponsiveSize.laptop} direction={FlexDirection.column}>
                <H1>Offering view report</H1>
                <Flex tileAfter={ResponsiveSize.laptop}>
                  <FlexContent direction={FlexDirection.column}>
                    <H2>Most viewed solutions of all time</H2>
                    <ViewTable
                      views={this.state.viewCounts.mostViewed}
                      nameAccessor="solution.solutionName"
                      viewAccessor="views"
                      nameHeader="Solution name"
                    />
                  </FlexContent>
                  <FlexContent direction={FlexDirection.column}>
                    <H2>Most viewed solutions in the last 90 days</H2>
                    <ViewTable
                      views={this.state.viewCounts.mostPopular}
                      nameAccessor="solution.solutionName"
                      viewAccessor="views"
                      nameHeader="Solution name"
                    />
                  </FlexContent>
                  <FlexContent direction={FlexDirection.column}>
                    <H2>Most downloaded materials of the last 90 days</H2>
                    <ViewTable
                      views={apiActions.getPopularMaterials(REPORT_ROW_COUNT)}
                      nameAccessor="title"
                      viewAccessor="contentVersionDownloadedCount"
                      nameHeader="File name"
                      idAccessor="relatedSolutionId"
                    />
                  </FlexContent>
                </Flex>
              </Flex>
            )}
          </WideContainer>
        )}
      </AppConsumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Report/Report.tsx